import VisibleLoading from '@/components/utilities/VisibleLoading';
import TextBlocks from '@/components/utilities/TextBlocks';

const QuestionsBlock = ({ title, questions }) => {
  return (
    <div className="mx-auto my-30 w-[90vw] xl:w-(--container-width)">
      {title && <h2 className="mb-8">{title}</h2>}

      {(questions || []).map((question) => (
        <Question key={question.id} {...question} />
      ))}
    </div>
  );
};
export default QuestionsBlock;

const Question = ({ question, answer }) => {
  return (
    <VisibleLoading delay={300}>
      {({ ref, className }) => (
        <details ref={ref} className={`group my-4 border-b border-gray-200 py-4 ${className || ''}`.trim()}>
          <summary className="flex w-full cursor-pointer list-none items-center justify-between bg-transparent p-0 text-left [&::-webkit-details-marker]:hidden">
            <h4 className="text-grey-950 text-xl font-semibold [[data-variant=dark]_&]:text-inherit">{question}</h4>

            <svg
              className="shrink-0 transition-transform duration-300 group-open:rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M9.88 11.0596L16 17.1662L22.12 11.0596L24 12.9396L16 20.9396L8 12.9396L9.88 11.0596Z"
                fill="currentColor"
              />
            </svg>
          </summary>
          <div className="text-grey-700 pt-5 pb-2 text-lg font-normal [[data-variant=dark]_&]:text-inherit">
            <TextBlocks template={answer} />
          </div>
        </details>
      )}
    </VisibleLoading>
  );
};
